import { useOutletContext } from "react-router-dom";
import { HomeHero } from "../components/sections/HomeHero";
import { MeetHonesti } from "../components/sections/MeetHonesti";
import { FeatureBento } from "../components/sections/FeatureBento";
import { Journey, Vision } from "../components/sections/Overview";
import { WaitlistCTA } from "../components/sections/WaitlistCTA";
import { Marquee } from "../components/site/Marquee";

export default function Home() {
  const { introOpen, introRun, replayIntro } = useOutletContext();
  return (
    <div data-testid="home-page">
      <HomeHero key={introRun} play={!introOpen} onReplay={replayIntro} />
      <Marquee />
      <MeetHonesti />
      <FeatureBento />
      <Journey />
      <Vision />
      <WaitlistCTA />
    </div>
  );
}
